/** @jsx jsx */
import { jsx } from 'theme-ui'
// @ts-strict-ignore
/* Original name @uswitch/trustyle.funnel-progress */

import { Fragment } from 'react'

// This is a bit of a hack to ensure that the progress bar starts after the 'step number'
const STARTING_PROGRESS = 0.1

const PhaseIcon = ({ variant, step }) => (
  <div
    sx={{
      variant: `elements.funnel-progress.base.phaseIcon.variants.${variant}`,
    }}
  >
    <If condition={variant === 'complete'}>
      <div sx={{ variant: 'elements.funnel-progress.base.phaseCompleteIcon.base' }}>{step}</div>
    </If>
    <Otherwise>{step}</Otherwise>
  </div>
)

const Percentage = ({ progress }) => {
  const percentage = `${Math.round((progress + 0.1) * 100)}%`
  return (
    <div
      sx={{
        variant: 'elements.funnel-progress.variants.percentage.displayPercentage',
      }}
    >
      {percentage}
    </div>
  )
}
const FunnelPhase = ({ step, open, complete, phase: { title } }) => (
  <div
    sx={{
      variant: !open
        ? 'elements.funnel-progress.base.phase.base'
        : 'elements.funnel-progress.base.phase.variants.open',
    }}
  >
    <div sx={{ variant: 'elements.funnel-progress.base.phaseLabel.base' }}>
      <div sx={{ variant: 'elements.funnel-progress.base.phaseLabelPart.base' }}>
        <PhaseIcon step={step} variant={open ? 'open' : complete ? 'complete' : 'incomplete'} />
      </div>
      {open && (
        <div sx={{ variant: 'elements.funnel-progress.base.phaseLabelPart.base' }}>{title}</div>
      )}
    </div>
  </div>
)

const FunnelProgress = ({
  phases,
  currentPhaseKey,
  progress,
  hideProgressBar,
  variant,
  ...rest
}) => {
  const currentPhaseIndex = phases.findIndex(({ key }) => key === currentPhaseKey)
  const percentageVariant = variant === 'percentage'

  const variantPath = (additionalPath = '') =>
    `elements.funnel-progress.${variant ? `variants.${variant}` : 'base'}${additionalPath}`

  const minWidth = percentageVariant ? '10%' : '0%'

  return (
    <Fragment>
      <div {...rest} sx={{ variant: variantPath() }}>
        {!percentageVariant &&
          phases.map((phase, ind) => (
            <FunnelPhase
              key={ind}
              step={ind + 1}
              open={ind === currentPhaseIndex}
              complete={ind < currentPhaseIndex}
              progress={progress}
              phase={phase}
            />
          ))}
        {percentageVariant && <Percentage progress={progress} />}
      </div>

      {!hideProgressBar && (
        <div
          sx={{
            variant: variantPath('.progess.back'),
            height: '4px',
            width: '100%',
            position: 'relative',
            backgroundColor: 'progress-bg',
            marginTop: '13px',
          }}
        >
          <div
            sx={{
              variant:
                progress !== 0
                  ? variantPath('.progress.base')
                  : variantPath('.progress.variants.start'),
            }}
            style={{
              width:
                progress !== 0
                  ? `${STARTING_PROGRESS * 100 + progress * (1 - STARTING_PROGRESS) * 100}%`
                  : minWidth,
            }}
          />
        </div>
      )}
    </Fragment>
  )
}

export default FunnelProgress
